import Money from 'common/components/layout/Money';

const CompareAtPrice = (props) => {
  const { variant, settings } = props;
  const price = variant.comparePrice || variant.price;
  if (!variant) {
    return null;
  }
  if (!variant.addToCartPrice || variant.addToCartPrice >= price) {
    return (
      <div className="c7-product__variant__price__normal">
        <Money number={price} settings={settings} />
        <span className="c7-product__variant__price__title">per person</span>
      </div>
    );
  }
  return (
    <div className="c7-product__variant__price__compare">
      <Money number={price} settings={settings} />
    </div>
  );
};

export default CompareAtPrice;
